module.exports = __webpack_public_path__ + "static/img/erweima1@2x.fd390fe.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/my/images/erweima1@2x.png
// module id = gRyg
// module chunks = 0